<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item md-size-20 no-padding">
        <pricing-card :icon-color="this.isCalling ? 'icon-info':'icon-default'">
          <h4 slot="category" class="category">
            <md-icon>headset_mic</md-icon>
            1002 상담사
          </h4>
          <md-icon slot="icon">contact_phone</md-icon>
          <h2 slot="title" class="title">
            {{ this.profile.memberHnm }}
          </h2>
          <p slot="title" class="sub-title">
            {{ this.profile.memberNo }}
          </p>
          <p slot="description" class="card-description">
            <md-icon v-if="profile.cellular">phone</md-icon>
            {{ this.profile.cellular }}
          </p>
          <div slot="footer" class="card-footer">
            <div class="mb10">
              <md-button
                slot="footer"
                class="md-info md-sm full-size-button"
                @click="() => {this.isShowMemberModal = true}"
              >
                <md-icon>open_in_new</md-icon>
                교우 검색
              </md-button>
            </div>
            <div class="mb10">
              <md-button
                slot="footer"
                class="md-sm full-size-button"
                :class="isCalling ? 'md-danger': 'md-info'"
                :disabled="profile.cellular === undefined"
                @click="onClickCall"
              >
                <md-icon>{{ this.isCalling ? "call_end":"call"}}</md-icon>
                전화 {{ this.isCalling ? "끊기" : "걸기"}}
              </md-button>
            </div>

            <div class="mb10">
              <md-button
                slot="footer"
                class="md-success md-sm full-size-button"
                v-if="profile.memberNo"
                @click="goSeveralManagement"
              >
                <md-icon>receipt_long</md-icon>
                회비 개별 처리
              </md-button>
            </div>

            <div v-if="isCalling">
              <div class="mb10">
                <table class="flex-table mb10">
                  <tr>
                    <th>상담 대분류</th>
                    <td>
                      <select
                        v-model="consulting.consult1Cd"
                        @change="changedConsult1CdType($event)"
                      >
                        <option selected value="">상담 대분류 선택</option>
                        <option v-for="item in consult1CdTypeList"
                          :key="item.code"
                          :value="item.code"
                          :label="item.codeNm"
                        ></option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <th>상담 소분류</th>
                    <td>
                      <select v-model="consulting.consult2Cd">
                        <option selected value="">상담 소분류 선택</option>
                        <option v-for="item in consult2CdTypeList"
                          :key="item.code"
                          :value="item.code"
                          :label="item.codeNm"
                        ></option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <th>메모</th>
                    <td>
                      <textarea class="h100"
                        v-model="consulting.consultDesc"
                      ></textarea>
                    </td>
                  </tr>
                </table>
              </div>
              <md-button
                slot="footer"
                class="md-info md-sm full-size-button"
                @click="saveConsulting"
              >
                <md-icon>check</md-icon>
                상담 처리
              </md-button>
            </div>
          </div>
        </pricing-card>
      </div>
      <div class="md-layout-item md-size-80 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>assignment</md-icon>
              교우 상세 정보
            </h4>
          </md-card-header>

          <div class="md-group tab-area">
            <md-button class="md-default" @click="onClickTab(1)">교우 기본 정보</md-button>
            <md-button class="md-default" @click="onClickTab(2)">교우 주소 정보</md-button>
          </div>
          <div class="simple-tab-group">
            <div v-if="showTab === 1">
              <md-card-content>
                <table class="flex-table">
                  <tr>
                    <th>교우명</th>
                    <td>
                      <ValidationProvider
                        name="profile.memberHnm"
                        :rules="{
                            required: true
                          }"
                      >
                        <input
                          type="text"
                          v-model="profile.memberHnm"
                        />
                      </ValidationProvider>
                    </td>
                    <th>개명전</th>
                    <td>
                      <input type="text" disabled />
                    </td>
                    <th>한자명</th>
                    <td>
                      <input type="text" v-model="profile.memberCnm" />
                    </td>
                    <th>영문명</th>
                    <td>
                      <input type="text" v-model="profile.memberEnm" />
                    </td>
                  </tr>
                  <tr>
                    <th>교우번호</th>
                    <td>
                      <ValidationProvider
                        name="profile.memberNo"
                        :rules="{
                            required: true,
                            regex: /^[a-zA-Z0-9]*$/,
                            min: 8
                          }"
                      >
                        <input type="text" v-model="profile.memberNo" />
                      </ValidationProvider>
                    </td>
                    <th>성별</th>
                    <td>
                      <ValidationProvider
                        name="profile.sex"
                        :rules="{
                            required: true
                          }"
                      >
                        <label>
                          <input
                            type="radio"
                            value="M"
                            v-model="profile.sex"
                          />
                          남
                        </label>
                        <label>
                          <input
                            type="radio"
                            value="F"
                            v-model="profile.sex"
                          />
                          여
                        </label>
                      </ValidationProvider>
                    </td>
                    <th>생년월일</th>
                    <td>
                      <!--
											<div class="inline-flex">
												<input type="text" v-model="profile.birthday" />
												<button>
													<md-icon>date_range</md-icon>
												</button>
											</div>
											-->
                      <!--
											<div class="md-small-size-100 md-size-33">
												<vuejsDatepicker
													format="yyyyMMdd"
													language="ko"
													v-model="profile.birthday"
												>
													<label>생년월일</label>
													<md-icon>date_range</md-icon>
												</vuejsDatepicker>
											</div>
											-->
                      <div
                        class="md-small-size-100 md-size-33"
                        style="border:1px solid #BBBBBB;"
                      >
                        <vuejsDatepicker
                          :language="datepickerLang"
                          :format="customFormatter"
                          v-model="profile.birthday"
                          placeholder="생년월일"
                        >
                          <!--<label>생년월일</label>-->
                        </vuejsDatepicker>
                      </div>
                    </td>
                    <th>교원</th>
                    <td>
                      <select v-model="profile.staffCd">
                        <option>교원아님</option>
                        <option
                          v-for="item in staffTypeList"
                          :key="item.code"
                          :label="item.codeNm"
                          :value="item.code"
                        >
                        </option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <th>휴대폰</th>
                    <td>
                      <div class="inline-flex">
                        <input type="text" v-model="profile.cellular" />
                        <!--<input type="text" maxlength="3" class="w40"
													v-model="profile.cellular"
												/>
												<input type="text" maxlength="4" />-->
                        <label><input type="checkbox" true-value="Y" false-value="N" v-model="profile.cellularDeny"/></label>
                      </div>
                    </td>
                    <th>출신고교</th>
                    <td>
                      <input type="text" v-model="profile.highschool" />
                    </td>
                    <th>국적</th>
                    <td>
                      <div class="inline-flex">
                        <input
                          type="text"
                          disabled
                          v-model="searchedNationalName"
                        />
                        <!--
												<button
													@click="
														() => {
															this.isShowNationalModal = true;
														}
													"
												>
													<md-icon>search</md-icon>
												</button>
												-->
                        <button v-on:click="activateShowNationalModal">
                          <md-icon>search</md-icon>
                        </button>
                      </div>
                    </td>
                    <td colspan="2"></td>
                  </tr>
                  <tr>
                    <th>단과대학</th>
                    <td>
                      <div class="inline-flex">
                        <input
                          type="text"
                          disabled
                          v-model="searchedCollegeName"
                        />
                        <input type="hidden" v-model="profile.collegeCd" />
                        <!--
												<button
													@click="
														() => {
															this.isShowCollegeModal = true;
														}
													"
												>
												-->
                        <!-- modified by psk 20200831 -->
                        <button v-on:click="activateShowCollegeModal">
                          <md-icon>search</md-icon>
                        </button>
                      </div>
                    </td>
                    <th>학과</th>
                    <td>
                      <div class="inline-flex">
                        <input
                          type="text"
                          disabled
                          v-model="searchedClassName"
                        />
                        <input type="hidden" v-model="profile.classCd" />
                        <!--
												<button
													@click="
														() => {
															this.isShowClassModal = true;
														}
													"
												>
													<md-icon>search</md-icon>
												</button>
												-->
                        <button v-on:click="activateShowDeptModal">
                          <md-icon>search</md-icon>
                        </button>
                      </div>
                    </td>
                    <th>학번</th>
                    <td>
                      <input type="text" v-model="profile.hakbun" />
                    </td>
                    <th>회원등급</th>
                    <td>
                      <select>
                        <option
                          v-for="item in memberLevelTypeList"
                          :key="item.code"
                          :label="item.codeNm"
                          :value="item.code"
                        ></option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <th>이메일 1</th>
                    <td>
                      <div class="inline-flex">
                        <input type="text" v-model="profile.eMail" />
                        <label><input type="checkbox" true-value="Y" false-value="N" v-model="profile.eMailDeny"/></label>
                      </div>
                    </td>
                    <th>이메일 2</th>
                    <td>
                      <div class="inline-flex">
                        <input type="text" v-model="profile.eMail2" />
                        <label><input type="checkbox" true-value="Y" false-value="N" v-model="profile.eMail2Deny"/></label>
                      </div>
                    </td>
                    <th>웹ID</th>
                    <td>
                      <input type="text" v-model="profile.webid" />
                    </td>
                    <th>웹가입일자</th>
                    <td>
                      <input
                        type="text"
                        disabled
                        v-model="profile.insertDate"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>소속단체</th>
                    <td>
                      <!-- 이거 작업해야 함
											<dl class="list-in-table">
												<dt>지부 :</dt>
												<dd>강남 / 부회장</dd>
												<dt>분회 :</dt>
												<dd>KT</dd>
												<dt></dt>
												<dd>사용자측 간사 단과대</dd>
												<dt></dt>
												<dd>상경대 / 총무</dd>
											</dl>
											-->
                    </td>
                    <th>가족교우</th>
                    <td>
                      <!-- 이거 작업해야 함
											<dl class="list-in-table">
												<dt>홍판서</dt>
												<dd>(K3123456)</dd>
											</dl>
											-->
                    </td>
                    <th>메모</th>
                    <td colspan="3">
                        <textarea
                          class="h100"
                          v-model="profile.remark"
                        ></textarea>
                    </td>
                  </tr>
                  <tr></tr>
                  <tr>
                    <th>평생회원</th>
                    <td class="emphasis">
                      {{ profile.memberGb }}
                    </td>
                    <th>교우직위</th>
                    <td>
                      {{ profile.memberorgGb }}
                    </td>
                    <th>최종납입년</th>
                    <td>
                      {{ profile.lastFeeYear }}
                    </td>
                    <th>최종납입일</th>
                    <td>
                      {{ profile.lastFeeDate }}
                    </td>
                  </tr>
                </table>
              </md-card-content>
            </div>
          </div>
          <div v-if="showTab === 2">
            <md-card-content>
              <div class="md-layout md-size-100">
                <div class="md-layout-item md-size-40 no-padding">
                  <h4>
                    우편물 수령
                    <span class="update-date" v-if="profile.updateDate && profile.updateDate!=''">변경일자 : {{ profile.updateDate }}</span>
                  </h4>
                  <table class="flex-table">
                    <tr>
                      <th>우편물 수령처</th>
                      <td>
                        <select v-model="profile.postplace">
                          <option value="H">자택(국내 거주지)</option>
                          <option value="C">국내 직장</option>
                          <option value="AH">해외 거주지</option>
                          <option value="AC">해외 직장</option>
                        </select>
                      </td>
                      <th>미발송 사유</th>
                      <td>
                        <select v-model="profile.postplace">
                          <option value="">선택</option>
                        </select>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="md-layout-item md-size-40 no-padding">
                  <!--dummy item for layout-->
                </div>
              </div>
              <div class="md-layout md-size-100">
                <div class="md-layout-item md-size-40 no-padding">
                  <h4>
                    국내 거주지
                    <span class="update-date" v-if="profile.updateDate && profile.updateDate!=''">변경일자 : {{ profile.updateDate }}</span>
                  </h4>
                  <table class="flex-table">
                    <tr>
                      <th>주소</th>
                      <td colspan="3">
                        <table class="table-in-td">
                          <tr>
                            <td>
                              <input
                                type="text"
                                v-model="profile.homeZipcd"
                                class="w70"
                                disabled
                                placeholder="우편번호"
                              />
                              <button v-on:click="addressModalOpen('1',$event)">
                                <md-icon>search</md-icon>
                                검색
                              </button>
                              <label
                              ><input type="checkbox" />반송지 확인</label
                              >
                              <label>
                                <input
                                  type="checkbox"
                                  true-value="Y"
                                  false-value="N"
                                  v-model="profile.homeStatus"
                                />
                                수신거부
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <input
                                type="text"
                                v-model="profile.homeAddress1"
                                disabled
                                placeholder="기본주소"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <input
                                type="text"
                                v-model="profile.homeAddress2"
                                placeholder="상세주소"
                              />
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <th>전화번호</th>
                      <td>
                        <div class="inline-flex">
                          <input type="text" v-model="profile.homeTel" />
                        </div>
                      </td>
                      <th>기타연락처</th>
                      <td>
                        <div class="inline-flex">
                          <input type="text" />
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="md-layout-item md-size-60 no-padding">
                  <h4>
                    국내 직장주소
                    <span class="update-date" v-if="profile.updateDate && profile.updateDate!=''">변경일자 : {{ profile.updateDate }}</span>
                  </h4>
                  <table class="flex-table">
                    <tr>
                      <th rowspan="3">주소</th>
                      <td colspan="3" rowspan="3">
                        <table class="table-in-td">
                          <tr>
                            <td>
                              <input
                                type="text"
                                v-model="profile.officeZipcd"
                                class="w70"
                                disabled
                                placeholder="우편번호"
                              />
                              <button v-on:click="addressModalOpen('2',$event)">
                                <md-icon>search</md-icon>
                                검색
                              </button>
                              <label
                              ><input type="checkbox" />반송지 확인</label
                              >
                              <label>
                                <input
                                  type="checkbox"
                                  true-value="Y"
                                  false-value="N"
                                  v-model="profile.officeStatus"
                                />
                                수신거부
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <input
                                type="text"
                                v-model="profile.officeAddress3"
                                disabled
                                placeholder="기본주소"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <input
                                type="text"
                                v-model="profile.officeAddress4"
                                placeholder="상세주소"
                              />
                            </td>
                          </tr>
                        </table>
                      </td>
                      <th>직장명</th>
                      <td>
                        <div class="inline-flex">
                          <input
                            type="text"
                            disabled
                            v-model="searchedCompanyName"
                          />
                          <button
                            @click="
                              (event) => {
                                if (event) {
                                  event.stopPropagation();
                                  event.preventDefault();
                                }
                                this.isShowCompanyModal = true;
                              }
                            "
                          >
                            <md-icon>search</md-icon>
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>직종</th>
                      <td>
                        <div class="inline-flex">
                          <input
                            type="text"
                            disabled
                            v-model="searchedWorkName"
                          />
                          <button
                            @click="
                              () => {
                                this.isShowWorkModal = true;
                              }
                            "
                          >
                            <md-icon>search</md-icon>
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>부서</th>
                      <td>
                        <input type="text" v-model="profile.partNm" />
                      </td>
                    </tr>
                    <tr>
                      <th>대표전화번호</th>
                      <td>
                        <div class="inline-flex">
                          <input type="text" v-model="profile.officeTel" />
                        </div>
                      </td>
                      <th>FAX번호</th>
                      <td>
                        <div class="inline-flex">
                          <input type="text" v-model="profile.officeFax" />
                        </div>
                      </td>
                      <th>직위</th>
                      <td>
                        <input type="text" v-model="profile.levelNm" />
                      </td>
                    </tr>
                    <tr>
                      <th>연락담당자</th>
                      <td><input type="text" /></td>
                      <th>담당번호</th>
                      <td><input type="text" /></td>
                      <th>직책</th>
                      <td><input type="text" v-model="profile.positionNm"/></td>
                    </tr>
                  </table>
                </div>
              </div>
            </md-card-content>
          </div>
        </md-card>
      </div>
    </div>

    <!-- --------------------------- Modal Popup --------------------------------------->
    <div>
      <!--교우검색 팝업 -->
      <member-search-pop-comp :is-show.sync="isShowMemberModal" @returnResult="onClickModalMember"></member-search-pop-comp>

      <!--직종선택 팝업 -->
      <work-search-pop-comp :is-show.sync="isShowWorkModal" @returnResult="selectedWork"></work-search-pop-comp>

      <!--직장선택 팝업 -->
      <company-search-pop-comp :is-show.sync="isShowCompanyModal" @returnResult="selectedCompany"></company-search-pop-comp>

      <!--대학선택 팝업 -->
      <college-search-pop-comp :is-show.sync="isShowCollegeModal" @returnResult="selectedCollege"></college-search-pop-comp>

      <!--학과선택 팝업 -->
      <class-search-pop-comp :is-show.sync="isShowClassModal" :m-code-cd.sync="profile.collegeCd" @returnResult="selectedDept"></class-search-pop-comp>

      <!--국가선택 팝업 -->
      <nation-search-pop-comp :is-show.sync="isShowNationalModal" @returnResult="selectedNational"></nation-search-pop-comp>

      <!--주소검색 팝업 -->
      <postcode-pop-comp :is-show.sync="isShowPostcodeModal" @returnResult="handleAddress"></postcode-pop-comp>

    </div>
    <!-- --------------------------- Modal Popup --------------------------------------->

  </div>
</template>

<script>
import {
  PricingCard
} from "@/components";
import Swal from "sweetalert2";
import moment from "moment";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

import { MemberSearchPopComp, WorkSearchPopComp, CompanySearchPopComp, CollegeSearchPopComp, ClassSearchPopComp, NationSearchPopComp, PostcodePopComp } from "@/pages"

// added by psk 20200901
import vuejsDatepicker from "vuejs-datepicker";
import { extend } from "vee-validate";
import { required, min, regex } from "vee-validate/dist/rules";
import { ko } from "vuejs-datepicker/dist/locale";

import axios from "axios";

import { Modal } from "@/components";

extend("required", required);
extend("min", min);
extend("regex", regex);

export default {
  components: {
    PricingCard,
    MemberSearchPopComp,
    WorkSearchPopComp,
    CompanySearchPopComp,
    CollegeSearchPopComp,
    ClassSearchPopComp,
    NationSearchPopComp,
    PostcodePopComp,
    vuejsDatepicker
  },
  data() {
    return {
      formatter,

      isShowMemberModal : false,
      isShowPostcodeModal: false,
      selectedAddressType: "1",

      showTab: 1,

      // 국적 조회
      nationalModalSearchText: "",// modal 에서 사용하는 검색어
      searchedNationalName: "",//modal 에서 검색 후 화면에 세팅하는 결과
      isShowNationalModal: false,//modal 보임/감춤
      nationalList: [],//modal 검색 결과 목록

      // 대학 선택 데이터
      collegeModalSearchText: "",
      searchedCollegeName: "",
      isShowCollegeModal: false,
      collegeList: [],

      // 학과 선택 데이터
      deptModalSearchText: "",
      searchedClassName: "",
      isShowClassModal: false,
      deptList: [],

      // 직종 검색
      searchedWorkName: "",
      isShowWorkModal: false,
      workList: [],

      // 직장명 검색
      searchedCompanyName: "",
      isShowCompanyModal: false,
      companyList: [],

      // 현재 통화중
      isCalling: false,

      // 모달을 통해 교우를 검색했음.
      profile: {},
      memberConsultHistory : [],

      // 교원 종류
      staffTypeList: [],
      // 회원 등급
      memberLevelTypeList: [],

      consult1CdTypeList: [],// 상담코드 대분류
      consult2CdTypeList: [],// 상담코드 소분류(대분류가 바뀌면 새로 로드함)
      consulting: {//목록에서 컨설팅 입력
        consult1Cd: "",
        consult2Cd: "",
        consultDesc: "",
      },
      datepickerLang: ko
    };
  },

  created() {
    // 교원종류 공통코드 조회
    this.queryStaffTypes();
    // 회원등급 공통코드 조회
    this.queryMemberLevelTypes();
    // 학력 사항 목록 조회 (기본 탭)
    this.inboundCall(this.$route.query.TelNo);
  },

  methods: {
    /**
     * 교원 여부 - 공통코드 조회 세팅
     */
    queryStaffTypes() {
      kuaaFnc.fncStaffTypes(null,res => {
        this.staffTypeList = res.data.data.contents;
      });
    },

    /**
     * 회원 등급 - 공통코드 조회 세팅
     */
    queryMemberLevelTypes() {
      kuaaFnc.fncMemberLevelTypes(null,res => {
        this.memberLevelTypeList = res.data.data.contents;
      });
    },

    onClickTab(index){
      this.showTab = index;
    },

    inboundCall(phoneNumber){
      let options = {
        cellular: phoneNumber,
        perPage: 1
      }
      kuaaApi.sendServer(
        URL_CONST.GET_MEMBER_LIST,
        options,
        "post",
        response => {
          let opt;
          if (response.data.data.pagination.totalCount === 1){
            opt = response.data.data.contents[0];
          } else {
            opt = {
              memberNo: undefined,
              memberHnm: "미확인",
              cellular: phoneNumber
            }
          }
          this.inboundCallModel(opt);
        }
      )
    },

    inboundCallModel(memberInfo) {
      Swal.fire({
        title: "Inbound Call",
        html: `<br><em class="phone-number">${memberInfo.cellular}</em><br>${memberInfo.memberHnm} ${memberInfo.memberNo}님 전화 입니다.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-info",
        cancelButtonClass: "md-button md-default",
        confirmButtonText: "전화 받기",
        cancelButtonText: "취소",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.isCalling = true;
          this.queryConsultCd1List();

          // 등록된 교우이면서 콜을 받는 경우 프로필 세팅해줌
          if (memberInfo.memberNo){
            this.profile = memberInfo;
            this.searchMemberConsultHistory();
          }
        }
      });
    },

    onClickCall() {
      this.isCalling = !this.isCalling;
      // 상담 대분류 로드
      this.queryConsultCd1List();
    },

    searchMemberConsultHistory (){
      let options = {
        memberNo: this.profile.memberNo
      };
      kuaaApi.sendServer(
        URL_CONST.GET_CONSULT_HIS_LIST,
        options,
        "post",
        response => {
          if (response.data.result){
            this.memberConsultHistory = response.data.data.contents;
          } else {
            this.memberConsultHistory = [];
          }
        }
      );

    },

    /**
     * 모달 교우선택 목록에서 교우를 선택 (교우 변경 기능)
     */
    onClickModalMember(item) {
      this.isShowMemberModal = false;
      this.profile = item;
      this.searchMemberConsultHistory();
    },

    selectedNational(item) {
      this.isShowNationalModal = false;
      this.searchedNationalName = item.codeNm;//화면 표시용
      // this.profile.nationalCd2 = item.nationalCd2;//DB 저장용
    },

    selectedCollege(item) {
      this.isShowCollegeModal = false;
      this.searchedCollegeName = item.codeNm;
      // this.profile.collegeCd = item.code;
      this.searchedClassName = ""; // 대학을 새로 선택했으므로 학과는 리셋 (collegeCd 는 윗줄에서 이미 리셋 됨)
    },

    selectedDept(item) {
      this.isShowClassModal = false;
      this.searchedClassName = item.codeNm;
      // this.profile.collegeCd = item.code;
      this.searchedCollegeName = item.groupNm
    },

    /**
     * 상담 대분류 공통코드 조회
     */
    queryConsultCd1List() {
      kuaaFnc.fncConsultLCodes(null,res => {
        this.consult1CdTypeList = res.data.data.contents;
      });
    },

    /**
     * 상담 대분류를 변경함 -> 소분류를 새로 로드함
     */
    changedConsult1CdType(e) {
      kuaaFnc.fncConsultSCodes(this.consulting.consult1Cd,null,res => {
        this.consult2CdTypeList = res.data.data.contents;
      });

    },

    /**
     * 상담사가 상담처리 버튼을 클릭
     */
    saveConsulting() {
      let params = {
        "memberNo":this.profile.memberNo,
        "callId":"00000000",
        "cCustId":this.profile.memberNo,
        "consult1Cd":this.consulting.consult1Cd,
        "consult2Cd":this.consulting.consult2Cd,
        "consultDesc":this.consulting.consultDesc
      }

      if(this.memberConsultHistory.length > 0){
        params['callId'] = this.memberConsultHistory[this.memberConsultHistory.length-1]['callId'];
      }

      let modalOptions = kuaaFnc.getSwalModaloptions();
      kuaaApi.sendServer(
        URL_CONST.SAVE_CONSULT,
        params,
        "post",
        response => {
          if (response.data.success){
            modalOptions.html = `처리 되었습니다.`;
            Swal.fire(modalOptions);
            this.onClickCall();
          } else {
            modalOptions.html = `처리 실패 하였습니다.`;
            Swal.fire(modalOptions);
          }
        }
      )

    },

    goSeveralManagement() {
      location.href = "/MembershipFee/SeveralManagement/" + this.profile.memberNo;
    },


    customFormatter(date) {
      let res = date && date != '' ? moment(date).format("YYYYMMDD") : '';
      return res;
    },
    activateShowCollegeModal(event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }

      this.isShowCollegeModal = true;
    },
    activateShowDeptModal(event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }

      if(this.profile.collegeCd){
        this.isShowClassModal = true;
      }else{
        Swal.fire({
          type: "warning",
          showCancelButton: false,
          confirmButtonClass: "md-button md-info",
          cancelButtonClass: "md-button md-default",
          confirmButtonText: "확인",
          buttonsStyling: false,
          html : '대학을 먼저 선택하세요'
        });
      }
    },
    activateShowNationalModal(event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }

      this.isShowNationalModal = true;
    },

    /**
     * 직종 검색
     */
    selectedWork: function(item) {
      this.isShowWorkModal = false;
      this.searchedWorkName = item.codeNm;
      this.profile.companyId = item.code;
      // this.searchedCompanyName = "";
    },
    /**
     * 직장명 검색
     */
    selectedCompany: function(item) {
      this.isShowCompanyModal = false;
      this.searchedCompanyName = item.codeNm;
      this.profile.companyId = item.code;
      // this.searchedWorkName = item.groupNm;
    },
    handleAddress: function(data) {
      let zonecode = data.zonecode; // 우편번호
      let roadAddress = data.roadAddress; // 도로명주소
      let jibunAddress = data.jibunAddress; // 지번 주소
      let fullAddress = data.address; // 기본주소
      let extraAddress = "";

      if (data.addressType === "R") {
        if (data.bname !== "") extraAddress += data.bname;
        if (data.buildingName !== "") {
          extraAddress +=
            extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
        }

        fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
      }

      if (this.selectedAddressType === "1") {
        this.profile.homeGb = data.addressType === "R" ? "1" : "0";
        this.profile.homeZipcd = zonecode;
        this.profile.homeAddress1 = jibunAddress;
        this.profile.homeAddress2 = extraAddress;
        this.profile.homeAddress3 = roadAddress;
        this.profile.homeAddress4 = "";
      } else if (this.selectedAddressType === "2") {
        this.profile.officeGb = data.addressType === "R" ? "1" : "0";
        this.profile.officeZipcd = zonecode;
        this.profile.officeAddress1 = jibunAddress;
        this.profile.officeAddress2 = extraAddress;
        this.profile.officeAddress3 = roadAddress;
        this.profile.officeAddress4 = "";
      }

      this.isShowPostcodeModal = false;
    },
    addressModalOpen: function(addressType,event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      this.isShowPostcodeModal = true;
      this.selectedAddressType = addressType;
    },
  }
};
</script>

<style scoped>
.card-footer{
  width: 100%;
}
h2.title{
  font-size: 40px;
  font-weight: 100;
}
p.sub-title{
  color: #999;
  font-size: 20px;
  margin: 20px 0 0 0;
}
p.card-description{
  margin: 5px 0 0 0;
}
.phone-number{
  font-size: 30px;
}
</style>